module.exports = __webpack_public_path__ + "fonts/careermap.284cfc7.ttf";